require('slick-carousel');
require('malihu-custom-scrollbar-plugin');
require('jquery-form-styler');

import WOW from 'wow.js';

$(function () {
    (function mobileBtn() {
        const mobileBtnOpen = $('.open-nav-btn');
        const mobileBtnClose = $('.close-menu');
        const mobileMenu = $('.header-nav');

        mobileBtnOpen.on('click', function(){
            mobileMenu.addClass('show');
            $(this).addClass('active');
            $('.overlay').addClass('show');
            $('body').addClass('no-scroll');
            $('html').addClass('no-scroll');
        });
        mobileBtnClose.on('click', function () {
            mobileMenu.removeClass('show');
            $(this).removeClass('active');
            $('.overlay').removeClass('show');
            $('body').removeClass('no-scroll');
            $('html').removeClass('no-scroll');
        });
    }());


    if ($(window).outerWidth() > 767) {
        $(".text-scroll").mCustomScrollbar({
            theme:"minimal"
        });
    }

    $('.testimonials-slider').slick({
        dots: false,
        speed: 600,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<div class="slick-prev"></div>',
        nextArrow: '<div class="slick-next"></div>',
        autoplay: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,

                }
            }
        ]
    });

    $('.boat-slider').on(`init reInit`, function(event, slick) {
        $('.counter #current-slide').text(1);
        $('.counter #total-slide').text(slick.slideCount);

    })
    $('.boat-slider').on(`afterChange`, function(event, slick, currentSlide, nextSlide) {
        $('.counter #current-slide').text(currentSlide + 1);
    })

    $('.boat-slider').slick({
        dots: false,
        speed: 600,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<div class="slick-prev"></div>',
        nextArrow: '<div class="slick-next"></div>',
        autoplay: false,
    });

    //shadow header on scroll
    $(window).scroll(function() {
        if ($(this).scrollTop() > 80){
            $('.header').addClass("header header--scroll");
        }
        else{
            $('.header').removeClass("header--scroll");
        }
    });

    if ($(window).outerWidth() < 575) {
        if ($(".footer-contacts").length) {
            (function () {
                $(".footer-contacts dd").children('br').remove();
            }());
        }
    }

    $('.right-side-block').stickybits();
});

new WOW().init();






